import Script from 'next/script'

import { initScript, openAiPixelId } from '@repo/analytics/openai'
import { useOpenAiUserMatching } from '@repo/analytics/openai/use-openai-user-matching'
import { IubendaSnippet } from './iubenda-snippet'
import { useIubendaConfig } from './iubenda'

export const OpenAiPixel = () => {
  const { gdprApplies, usprApplies, scriptProps, variant } = useIubendaConfig()
  useOpenAiUserMatching()

  if (!openAiPixelId || variant === 'locationNotSet') {
    return null
  }

  return gdprApplies || usprApplies ? (
    <IubendaSnippet
      purposes={scriptProps['data-iub-purposes']}
      defer={scriptProps['data-cf-defer']}
      id="openai-pixel-script"
    >
      {initScript}
    </IubendaSnippet>
  ) : (
    <Script id="openai-pixel-script" strategy="afterInteractive" {...scriptProps}>
      {initScript}
    </Script>
  )
}
